import { faMoneyBill1Wave } from '@fortawesome/pro-light-svg-icons';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { Button, IconBox, Link } from '~/common/components';
import { formatMoney } from '~/common/utils';
import { routes } from '~/constants';
import { useCurrentUserData } from '../../../../Auth';
import { useNavigation } from '../../../context';

export const CreditBalanceMenu = () => {
  const { isMenuCollapsed } = useNavigation();
  const { customerRole } = useCurrentUserData();

  if (isMenuCollapsed && customerRole !== 'owner') {
    return null;
  }

  return (
    <div className="border border-solid border-other-300 rounded-md bg-text-100">
      {isMenuCollapsed ? <CreditBalanceMenuCollapsed /> : <CreditBalanceMenuExpanded />}
    </div>
  );
};

const CreditBalanceMenuCollapsed = () => {
  const { subscriptionSuspension } = useCurrentUserData();

  if (subscriptionSuspension?.isSuspended) {
    return (
      <div
        className="flex px-2 py-[12px] cursor-not-allowed"
        data-tt="Reactivate your account to purchase credit packages."
        data-tt-placement="right"
      >
        <IconBox size="s" icon={faMoneyBill1Wave} />
      </div>
    );
  }
  return (
    <Link.Base
      to={routes.profile.billing.credits}
      className="flex px-2 py-[12px]"
      data-tt="Get more credits"
      data-tt-placement="right"
    >
      <IconBox size="s" icon={faMoneyBill1Wave} />
    </Link.Base>
  );
};

const CreditBalanceMenuExpanded = () => {
  const { balance } = useCurrentUserData();
  const { subscriptionSuspension, customerRole, hidePrices } = useCurrentUserData();

  if (hidePrices || balance === null) {
    return null;
  }

  return (
    <div className="flex px-2 py-[12px]">
      <div className="flex flex-col gap-[12px]">
        <span className="font-brand-b3">Your balance</span>
        <p className="font-brand-h5 text-text-600">{formatMoney(balance)}</p>
        {customerRole === 'owner' && !subscriptionSuspension?.isSuspended && (
          <Link
            color="navy"
            size="m"
            to={routes.profile.billing.credits}
            className="w-fit"
            endIcon={faChevronRight}
          >
            Get more credits
          </Link>
        )}
        {customerRole === 'owner' && subscriptionSuspension?.isSuspended && (
          <Button
            disabled
            endIcon={faChevronRight}
            color="text-navy"
            size="m"
            data-tt="Reactivate your account to purchase credit packages."
          >
            Get more credits
          </Button>
        )}
      </div>
    </div>
  );
};
